import { render, staticRenderFns } from "./CompFooterEcommerceModal.vue?vue&type=template&id=30e3ebd5"
import script from "./CompFooterEcommerceModal.vue?vue&type=script&lang=js"
export * from "./CompFooterEcommerceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports